"use strict";

// ---------------------------------------------------
// Load Super Class

var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Module Definition

var ItemAttributes = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var ItemAttributesCollection = require('bunsen/collections/inventory/ItemAttributes');
var ItemAttributesPeriodCollection = require('bunsen/collections/inventory/ItemAttributesPeriod');
var ItemAttributesProductionTypeCollection = require('bunsen/collections/inventory/ItemAttributesProductionType');
var ItemAttribute = require('bunsen/models/inventory/ItemAttribute');

// ---------------------------------------------------
// Local Vars

var HasMany = Backbone.Many;

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemAttributes.prototype, {
    relations: [
        {
            key: ItemAttribute.ATTRIBUTE_MATERIAL,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_TECHNIQUE,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_METAL,
            collectionType : ItemAttributesCollection,
            type: HasMany,
            omitFromSave : true
        },
        {
            key: ItemAttribute.ATTRIBUTE_STONE,
            collectionType : ItemAttributesCollection,
            type: HasMany,
            omitFromSave : true
        },
        {
            key: ItemAttribute.ATTRIBUTE_STYLE,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_STYLE_OF,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_ORIGIN,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_PERIOD,
            collectionType : ItemAttributesPeriodCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_LEAD_TIME,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_PRODUCTION_TYPE,
            collectionType : ItemAttributesProductionTypeCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_COLOR,
            collectionType : ItemAttributesCollection,
            type: HasMany
        }
    ],

    getAttributeIdsFor: function (attributeType) {
        var attributeCollection = this.get(attributeType) || [];
        return attributeCollection.map(function (attribute) {
            return attribute.get('option.id');
        });
    },

    getAttributeIdFor: function (attributeType) {
        var ids = this.getAttributeIdsFor(attributeType);
        return ids.length && ids[0];
    },

    getAttributeValuesFor: function (attributeType) {
        var attributeCollection = this.get(attributeType) || [];
        return attributeCollection.map(function (attribute) {
            return attribute.get('option.id');
        });
    },

    getAttributeValueFor: function (attributeType) {
        var vals = this.getAttributeValuesFor(attributeType);
        return vals.length && vals[0];
    },

    /**
     * @returns {*}
     */
    getStyleAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_STYLE);
    },

    /**
     * @returns {*}
     */
    getStyleOfAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_STYLE_OF);
    },

    /**
     * Get materials and techniques collection with synced attributes
     * @returns {ItemAttributesCollection}
     */
    getMaterialsTechniquesCollection: function () {
        var materials = this.get(ItemAttribute.ATTRIBUTE_MATERIAL) ? this.get(ItemAttribute.ATTRIBUTE_MATERIAL).toJSON() : [];
        var techniques = this.get(ItemAttribute.ATTRIBUTE_TECHNIQUE) ? this.get(ItemAttribute.ATTRIBUTE_TECHNIQUE).toJSON() : [];
        var collection = new ItemAttributesCollection();

        // Set materials
        _.each(materials, function (material) {
            if (material.groupKey) {
                // Find grouped technique
                _.each(techniques.slice(0), function (technique, index) {
                    if (technique.groupKey && technique.groupKey === material.groupKey) {
                        techniques.splice(index, 1);

                        collection.add({
                            material: material,
                            technique: technique
                        });
                    }
                });
            } else {
                // Just material
                collection.add({
                    material: material
                });
            }
        });

        // Set techniques (no more groups)
        _.each(techniques, function (technique) {
            collection.add({
                technique: technique
            });
        });

        return collection;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/ItemAttributes.js
// module id = 2055
// module chunks = 64